/**
* DevExpress Dashboard (_layout-utils.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ModelSerializer } from '@devexpress/analytics-core/analytics-utils';
export var _layoutItemTypeMap = {};
export function deserializeDashboardLayoutNode(itemModel, serializer = new ModelSerializer()) {
    var itemType = itemModel['@ItemType'];
    return new _layoutItemTypeMap[itemType](itemModel, serializer);
}
